import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/Layout";
import Seo from "../components/Seo";
import Header from "../components/Header";
import DynamicChildren from "../components/DynamicChildren";

import { hydrateBlogPosts } from "../utils/utils";

import "../styles/pages/blog.scss";

const BlogLanding = ({ pageContext, location, data }) => {
    const { page, topic } = data;
    const { header, dynamicComponents } = page;
    const blogPosts = hydrateBlogPosts(
        topic ? data.blogPostsByTopic : data.blogPostsByType,
    );

    return (
        <Layout className="blog blog-landing" location={location}>
            <Header header={header} banner={page.banner} location={location} />

            <DynamicChildren
                contentfulComponents={dynamicComponents}
                topic={topic}
                blogPosts={blogPosts}
                {...pageContext}
            />
        </Layout>
    );
};

export const Head = ({ data }) => {
    const { page, topic } = data;
    const title = topic ? `ShiftMed Blog: ${topic.name}` : "ShiftMed Blog";
    const meta = [];

    if (page.header?.heroImage?.url) {
        meta.push({
            key: "og:image",
            property: "og:image",
            content: page.header.heroImage.url,
        });
    }

    return <Seo defaultTitle={title} page={page} meta={meta} />;
};

export default BlogLanding;

export const PageQuery = graphql`
    query BlogLandingPageQuery(
        $slug: String
        $limit: Int!
        $skip: Int!
        $featuredSlug: String
        $type: String
        $blogPrefix: String
    ) {
        page: contentfulPage(path: { eq: $blogPrefix }) {
            header {
                ...HeaderData
            }
            banner {
                ...Banner
            }
            ...DynamicComponents
            seoTitle
            seoDescription {
                seoDescription
            }
            seoRobots
        }
        topic: contentfulBlogTopic(slug: { eq: $slug }) {
            name
            slug
        }
        blogPostsByTopic: allContentfulArticle(
            filter: {
                dummy: { ne: true }
                slug: { ne: $featuredSlug }
                topics: { elemMatch: { slug: { eq: $slug } } }
                type: { eq: $type }
            }
            sort: { publishDate: DESC }
            limit: $limit
            skip: $skip
        ) {
            edges {
                node {
                    slug
                    publishDate
                    image {
                        gatsbyImageData(layout: CONSTRAINED)
                        title
                        description
                        file {
                            contentType
                            url
                        }
                    }
                    title
                    topics {
                        slug
                        name
                    }
                    body {
                        raw
                    }
                }
            }
        }
        blogPostsByType: allContentfulArticle(
            filter: {
                dummy: { ne: true }
                slug: { ne: $featuredSlug }
                type: { eq: $type }
            }
            sort: { publishDate: DESC }
            limit: $limit
            skip: $skip
        ) {
            edges {
                node {
                    slug
                    publishDate
                    image {
                        gatsbyImageData(layout: CONSTRAINED)
                        title
                        description
                        file {
                            contentType
                            url
                        }
                    }
                    title
                    topics {
                        slug
                        name
                    }
                    body {
                        raw
                    }
                }
            }
        }
    }
`;
